import { render } from "./App.vue?vue&type=template&id=9dbc9dbc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9dbc9dbc&lang=css"

import exportComponent from "/etc/ec/smsdrm/sms/sms_ui_2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__